<template>
  <v-container>
    <div v-if="!loaded"><p>Loading encounter data...</p></div>
    <div v-else ref="form"> <!-- vuetify -->
      <patient-identity :patient="patient"></patient-identity>
      <h2 class="mt-8 text-xl">Encounter details</h2>
      <v-layout><!-- vuetify -->
        <v-flex xs3 sm2 md2><!-- vuetify -->
          <v-text-field
            v-model="encounter.systemId"
            label="Encounter ID"
          ></v-text-field><!-- vuetify -->
        </v-flex>
        <div class="flex-none w-48 pt-4 px-1">
          <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
            Provider
          </label>
          <dropdown v-model="encounter.serviceProvider.display" :options="serviceProviders" display-property="display" value-property="display"></dropdown>
        </div>
        <!-- <v-flex xs4 sm3 md3>
          <v-select
            v-model="id.assigner"
            :items="serviceProviders"
            item-text="display"
            item-value="display"
            :rules="[v => !!v || 'Item is required']"
            label="Provider"
            return-object
            required
          ></v-select>
        </v-flex> -->
        <div class="flex-none w-40 pt-4 px-1">
          <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
            Encounter type
          </label>
          <dropdown v-model="encounter.basedOn" :options="planDefinitions" display-property="title" value-property="id"></dropdown>
        </div>
        <!-- <v-flex xs4 sm3 md3>
          <v-select
            v-model="encounter.basedOn"
            :items="planDefinitions"
            item-text="title"
            item-value="id"
            :rules="[v => !!v || 'Item is required']"
            label="Encounter type"
            required
          ></v-select>
        </v-flex> -->
        <div class="flex-none w-48 pt-4 px-1">
          <text-field :wipe=true :value="encounter.period.start | localeDate" label="Encounter date" hint="dd/mm/yyyy" @input="encounter.period.start = isoDate($event)" >
          </text-field>
          <!-- <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            full-width
            max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formattedDate"
                clearable
                label="Date of encounter"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="encounter.period.start"
              @change="dateMenu = false"
            ></v-date-picker>
          </v-menu> -->
        </div>
      </v-layout>
      <v-layout row v-if="!saved">
        <v-btn
        :disabled="!valid"
        class="mr-4"
        @click="createEncounter">
          Create encounter
        </v-btn>
      </v-layout>
      <div v-if="saved">
        <div class="w-full grid grid-cols-6 gap-1 ml-2 mb-4">
          <div class="col-span-1 pt-4 px-1">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              Employment status
            </label>
            <dropdown v-model="results.Observation.EmploymentStatus" :options="employmentStatuses"></dropdown>
          </div>
          <div v-if="encounter.basedOn === '10001'" class="col-span-1 pt-4 px-1">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              Referrer
            </label>
            <dropdown v-model="encounter.referral" :options="referral"></dropdown>
          </div>
          <div v-if="encounter.referral" class="col-span-1 w-40 pt-4 px-1">
            <text-field :value="encounter.referralDate | localeDate" label="Referral date" hint="dd/mm/yyyy" @input="encounter.referralDate = isoDate($event)"></text-field>
          </div>
        </div>
        <h2 class="title">{{plan.title}}</h2>
        <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
          <span class="text-sm text-gray-800">Patient Reported Outcomes</span>
        </div>
        <button
          class="bg-gray-100 hover:bg-gray-400 font-medium rounded-sm shadow text-sm uppercase mr-4 p-2"
          @click="launchSurvey('oahks-womac')">
          Launch WOMAC survey
        </button>
        <button
          class="bg-gray-100 hover:bg-gray-400 font-medium rounded-sm shadow text-sm uppercase mr-4 p-2"
          @click="launchSurvey('vr-12')">
          Launch VR-12 survey
        </button>
        <button
          class="bg-gray-100 hover:bg-gray-400 font-medium rounded-sm shadow text-sm uppercase mr-4 p-2"
          @click="smsSurvey('oahks-pre-visit')">
          <span class="float-left">SMS combined surveys</span>
          <transition name="sent-indicator">
            <span v-if="smsSent" class="float-left">
              <svg version="1.1" id="tick" class="w-1/12 -mr-10" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 37 37" style="enable-background:new 0 0 37 37;" xml:space="preserve">
                <path :class="$style.circ" style="fill:none;stroke:#000;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" d="M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"/>
                <polyline class="tick path" style="fill:none;stroke:#000;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" points="11.6,20 15.9,24.2 26.4,13.8 "/>
              </svg>
            </span>
          </transition>
        </button>
        <div class="w-full grid grid-cols-6 gap-1">
          <button
            class="bg-gray-100 hover:bg-gray-400 font-medium rounded-sm shadow text-xs uppercase mt-4 p-2"
            @click="toggleObservation('visual_analogue_scale')">
            <span v-if="!results.Observation.visual_analogue_scale">Enter</span><span v-else>Delete</span> Visual Analogue Scale
          </button>
          <div v-if="results.Observation.visual_analogue_scale" class="col-span-1 w-48 pt-4 px-1">
            <!--<range max="10"/>-->
            <div class="flex-none w-48 pt-4 px-1"></div>
            <input type="range" min="0" max="10" step="1" v-model="results.Observation.visual_analogue_scale" />
            <label class="inset-0 transition ease-in duration-200 relative mb-0 leading-tighter">
              {{results.Observation.visual_analogue_scale}}
            </label>
          </div>
        </div>
        <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
          <span class="text-sm text-gray-800">Clinical Evaluation</span>
        </div>
        <div class="w-full grid grid-cols-4 gap-1 ml-4">
          <div class="col-span-1 w-36 pt-4 px-1">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              pain areas:
            </label>
            <dropdown
              v-model="$data.results.Observation.pain_area"
              multi
              :options="painAreas">
            </dropdown>
          </div>
          <div class="col-span-1 w-36 pt-4 px-1">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              Index joint
            </label>
            <dropdown v-model="results.Observation.oa_index_joint" :options="joints"></dropdown>
          </div>
          <div v-if="results.Observation.oa_index_joint" class="col-span-1 w-32 pt-4 px-1">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              {{results.Observation.oa_index_joint}} x-ray:
            </label>
            <dropdown
              v-model="$data.results.Observation[toSnakeCase(results.Observation.oa_index_joint) + '_xray'].status"
              :options="xrayStatuses">
            </dropdown>
          </div>
          <div v-if="results.Observation.oa_index_joint" class="col-span-2 pt-4 px-1">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              Kellgren-Lawrence grade
            </label>
            <dropdown
              v-model="$data.results.Observation[toSnakeCase(results.Observation.oa_index_joint) + '_kl']"
              :options="kellgrenLawrenceGrades"
              displayProperty="desc"
              valueProperty="grade">
            </dropdown>
            <div class="mt-6" v-if="results.Observation.oa_index_joint">
              <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
                Range of movement
              </label>
              <dropdown
                v-model="$data.results.Observation[toSnakeCase(results.Observation.oa_index_joint) + '_range']"
                :options="rangeOfMovement">
              </dropdown>
            </div>
          </div>
        </div>
        <!-- <v-layout row>
          <v-flex xs3 sm2 md2>
            <v-text-field
              v-model="results.Observation.height"
              label="Height (cm)"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm2 md2 offset-xs1>
            <v-text-field
              v-model="results.Observation.weight"
              label="Weight (kg)"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 sm2 offset-xs1>
            <v-text-field label="BMI"
            placeholder="BMI"
            outlined
            disabled
          ></v-text-field>
          </v-flex> 
        </v-layout> -->
        <div class="d-flex">
          <!-- <div v-for="(action, index) of plan.action" :key="index">
           
            <div v-if="action.output.type === 'Observation' && action.output.profile.validCodedValueSet && action.output.profile.multipleResultsAllowed">
              <v-select
                :v-model="`results.Observation.${getInputCoding(action.output.profile.coding).code}`"
                :items="joints"
                :label="getInputCoding(action.output.profile.coding).display"
                multiple
              ></v-select>
            </div>
            
            <div v-else-if="action.output.type === 'Observation' && action.output.profile.validCodedValueSet">
              <div class="flex-none w-48 pt-4 px-1">
                <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
                  {{ getInputCoding(action.output.profile.coding).display }}
                </label>
                <dropdown :v-model="`results.Observation.${getInputCoding(action.output.profile.coding).code}`" :options="joints"></dropdown>
              </div>
            
            </div>
            <div :class="$style.quantcontainer" v-else-if="action.output.type === 'Observation' && action.output.profile.quantitativeDetails">
              <div :class="$style.quantfield">
                <v-text-field
                  :v-model="`Observation.${action.output.profile.preferredReportName}`"
                  :label="getInputCoding(action.output.profile.coding).display"
                ></v-text-field>
              </div>
              <div :class="$style.quantunit">{{action.output.profile.quantitativeDetails.unit}}</div>
            </div>
            <v-layout dflex v-if="action.output.profile.systemId">
              <v-flex xs4 sm3 md3 v-if="action.output.profile.systemId=='100007'">
                <v-select
                  v-model="results.Observation.joint_pain_sites"
                  :items="painAreas"
                  label="Pain area"
                  multiple
                ></v-select>
              </v-flex>
            </v-layout>
            <div v-if="action.output.type === 'Observation' && action.output.profile.permittedDataType === 'object'">
              <div v-for="(component, index) in action.output.profile.components" :key="index">
                {{action.output.type}} - {{ component.valueType }}
                {{ getInputCoding(component.coding)}}
              </div>
            </div>
          </div> -->
        </div>
      <!-- <v-layout row v-for="(joint, index) in jointObservations" :key="index">
        <v-flex xs4 sm3 md3>
          <v-select
            v-model="joint.bodyPart"
            :items="joints"
            :rules="[v => !!v || 'Item is required']"
            label="Joint"
            required
            @change="onJointSelected($event)"
          ></v-select>
        </v-flex>
        
        <v-flex xs2 sm2 md2>
          <v-checkbox
            v-model="joint.index"
            label="Index joint?:"
          ></v-checkbox>
        </v-flex>
        <v-btn @click="addJoint">Add joint</v-btn>
        </v-layout> -->
        <!-- <v-list subheader three-line>
          <v-subheader>Assessment</v-subheader>
          <v-list-item v-for="(action, index) in assessmentActions" :key="index">
            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ action.description }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
          <!-- <v-list-item-group v-model="selected" multiple active-class="pink--text">
            <template v-for="(action, index) in assessmentActions">
              <v-list-item :key="action.title">
                <template v-slot:default="{ active, toggle }">
                <v-list-item-content>
                  <v-list-item-title v-text="action.title"></v-list-item-title>
                  <v-list-item-subtitle class="text--primary" v-text="action.title"></v-list-item-subtitle>
                  <v-list-item-subtitle v-text="action.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text v-text="action.profile"></v-list-item-action-text>
                  <v-icon
                    v-if="!active"
                    color="grey lighten-1"
                  >
                    star_border
                  </v-icon>
                  <v-icon
                    v-else
                    color="yellow"
                  >
                    star
                  </v-icon>
                </v-list-item-action>
              </template>
              </v-list-item>
            </template>
          </v-list-item-group> -->
        <!-- </v-list> -->
        <!-- <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Assessment</v-expansion-panel-header>
            <v-expansion-panel-content>
              <a href="https://ctc4.typeform.com/to/F3K2g8">Add HOOS</a>
              <a href="https://ctc4.typeform.com/to/F3K2g8">Add KOOS</a>
              <a href="https://ctc4.typeform.com/to/F3K2g8">Add Clinical Observation</a>
              <v-select
                v-model="distance"
                :items="walkingDistances"
                label="Walking distance"
                required
              ></v-select>
              Co-morbidities
              Modified Kellgren / Lawrence
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Prior intervention outcome</v-expansion-panel-header>
            <v-expansion-panel-content>
              VAS Pain
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Treatment</v-expansion-panel-header>
            <v-expansion-panel-content>
              Score?
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
      </div>
      <div v-if="saved" class="w-full flex ml-4">
        <div class="flex-none w-60 pt-4 px-1">
          <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
            Walking distance
          </label>
          <dropdown
            v-model="results.Observation.WalkingDistance"
            :options="walkingDistances">
          </dropdown>
        </div>
      </div>
      <div v-if="saved" class="mt-4 w-full flex ml-4">
        <text-field v-model="results.height" label="Height" class="col-span-2"></text-field><span class="mt-2 ml-1 text-gray-600">cm</span>
        <text-field v-model="results.weight" label="Weight" class="ml-4"></text-field><span class="mt-2 ml-1 text-gray-600">kg</span>
        <span v-if="results.height && results.weight" class="mt-2 ml-2 text-gray-600">BMI: {{bmi}} kg/m</span><span v-if="results.height && results.weight" class="sup text-gray-600">2</span>
      </div>
      <div row v-if="saved">
        <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
          <span class="text-sm text-gray-800">Charlson Comorbidity Index</span>
        </div>
        <v-layout row wrap d-flex>
          <!-- <three-way-toggle :status="false"></three-way-toggle> -->
          <button
            class="bg-gray-100 hover:bg-gray-400 font-medium rounded-sm shadow text-sm uppercase mr-4 p-2"
            @click="toggleCharlson">
            <span v-if="!results.Observation.charlson">Assess</span><span v-else>Delete</span> Charlson Comorbidity Index
          </button>
          <charlson-comorbidity v-if="results.Observation.charlson" v-model="results.Observation.charlson"></charlson-comorbidity>
          <!-- <v-checkbox
            v-for="(value, propertyName, index) in results2.charlson"
            :key="index"
            :v-model="`results2.comorbs[${propertyName}]`"
            class="mx-2 d-flex" :label="propertyName">
          </v-checkbox> -->
        </v-layout>
        <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
          <span class="text-sm text-gray-800">Treatment</span>
        </div>
        <div class="w-full grid grid-cols-6 gap-1 ml-4">
          <div class="col-span-1 my-4">
            <div class="flex items-center">
              <input id="injection_steriod" type="checkbox" v-model="results.Procedure.injection_steroid" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
              <label for="injection_steriod'" class="ml-2 block text-sm text-gray-900">
                Corticosteroid injection
              </label>
            </div>
          </div>
          <div class="col-span-1 my-4">
            <div class="flex items-center">
              <input id="injection_steriod" type="checkbox" v-model="results.Procedure.joint_aspiration" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
              <label for="injection_steriod'" class="ml-2 block text-sm text-gray-900">
                Joint aspiration
              </label>
            </div>
          </div>
          <div v-if="results.Procedure.joint_aspiration" class="col-span-2 flex my-4">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              Appearance
            </label>
            <dropdown v-model="results.Observation.synovial_fluid_analysis" :options="synovialFluidAppearences"></dropdown>
            <text-field v-model="results.Observation.aspirate_volume" label="Vol" class="ml-2 w-16"></text-field><span class="mt-2 ml-1 text-sm text-gray-600">ml</span>
          </div>
        </div>
        <div class="w-full grid grid-cols-6 gap-1 ml-4">
          <div class="col-span-1 my-2">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              Outcome
            </label>
            <dropdown v-model="results.Custom.oahks_outcomes" :options="outcomes" multi></dropdown>
          </div>
          <div class="col-span-2">
            <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
              OAHKS outcome coding
            </label>
            <dropdown
              v-model="results.Custom.oahks_coded_outcome"
              :options="oahksCoding"
              displayProperty="desc"
              valueProperty="grade">
            </dropdown>
          </div>
        </div>
      </div>
      <v-layout row v-if="saved" class="mt-2">
        <v-btn :disabled="!valid" class="mr-4" @click="saveEncounter">Save</v-btn>
        <v-btn class="mr-4">Reset</v-btn>
      </v-layout>
    </div>
    <v-snackbar v-model="encounterSaveSnackbar" :bottom="true" :left="false"
      :right="false" :timeout=6000 :top="false" :vertical="true">
      Encounter record saved.
      <button @click="encounterSaveSnackbar = false" class="text-gray-100 hover:text-yellow-400 font-medium rounded-sm shadow text-xs uppercase w-8 mt-4 p-2">
        Close
      </button>
    </v-snackbar>
  </v-container>
</template>

<script>
import apiCall from '../utils/api'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { DateTime } from 'luxon'
import dayjs from 'dayjs'
import querystring from 'querystringify'
import CharlsonComorbidity from '@/components/CharlsonComorbidity.vue'
import Dropdown from '@/components/Dropdown.vue'
import ObservationEdit from '@/components/ObservationEdit.vue'
import PatientIdentity from '@/components/PatientIdentity.vue'
import Range from '@/components/Range.vue'
import TextField from '@/components/TextField.vue'
import ThreeWayToggle from '@/components/ThreeWayToggle.vue'

dayjs.extend(customParseFormat)

export default {
  components: {
    CharlsonComorbidity, Dropdown, ObservationEdit, PatientIdentity, Range, TextField, ThreeWayToggle
  },
  data () {
    return {
      assessmentActions: [
        { 'title': 'Comorbidity', 'description': 'Co-morbidities including Charlson Comorbidity Index', 'profile': 'Comorbidity' },
        { 'title': 'BMI', 'description': 'Body Mass Index', 'profile': 'BMI' },
        // {'title': 'Modified Kellgren-Lawrence', 'profile': 'KellgrenLawrence'},
        { 'title': 'HOOS', 'description': 'HOOS Hip Survey','profile': 'Survey' },
        { 'title': 'KOOS', 'description': 'KOOS Knee Survey','profile': 'Survey' },
        { 'title': 'SF-12', 'description': 'Short-form health-related quality of life survey','profile': 'Survey' }
      ],
      dateMenu: false,
      distance: '',
      employmentStatuses: ['yes', 'no'],
      encounter: {},
      encounterDateLocale: '',
      encounterSaveSnackbar: false,
      jointObservations: [{ bodyPart: '', painArea: '', index: true }],
      joints: ['Right knee', 'Left knee', 'Right hip', 'Left hip', 'Spine'],
      kellgrenLawrenceGrades: [
        { grade: 0, desc: '0 - no radiographic features of OA are present' },
        { grade: 1, desc: '1 - doubtful joint space narrowing (JSN) and possible osteophytic lipping' },
        { grade: 2, desc: '2 - definite osteophytes and possible JSN on anteroposterior weight-bearing radiograph' },
        { grade: 3, desc: '3 - multiple osteophytes, definite JSN, sclerosis, possible bony deformity' },
        { grade: 4, desc: '4 - large osteophytes, marked JSN, severe sclerosis and definite bony deformity' }
      ],
      loaded: false,
      oahksCoding: [
        { grade: 'A1', desc: 'A1 - ready for surgery' },
        { grade: 'A2', desc: 'A2 - surgery probable' },
        { grade: 'A3', desc: 'A3 - surgery opinion' },
        { grade: 'A4', desc: 'A4 - arthroscopy' },
        { grade: 'B1', desc: 'B1 - conservative therapy' },
        { grade: 'B2', desc: 'B2 - too unwell' },
        { grade: 'B3', desc: 'B3 - refusal surgery' },
        { grade: 'C', desc: 'C - non OA' },
        { grade: 'Other', desc: 'Other' }
      ],
      oldResults: {},
      outcomes: ['discharge', 'referred to non-surgical care', 'referred to radiology', 'surgical review', 'review in OAHKS'],
      painAreas: ['Anterior knee', 'Medial knee', 'Lateral knee', 'Posterior knee', 'Lower leg', 'Lumbar', 'Groin', 'Lateral hip', 'Posterior hip'],
      patient: {},
      plan: {},
      planDefinitions: [],
      rangeOfMovement: ['< 90', '> 90'],
      referral: ['GP', 'internal specialist', 'external specialist'],
      results: {
        ClinicalImpression: {},
        Custom: {},
        Observation: {},
        Procedure: {},
        Questionnaire: {},
        ServiceRequest: {}
      },
      results2: {
        hip_kl: '',
        knee_kl: '',
        xray_knee: { status: '' }
      },
      saved: false,
      selected: [0],
      serviceProviders: this.$store.state.init.org.valueLists.encounterProviders,
      smsSent: false,
      smsTelecom: '',
      synovialFluidAppearences: ['clear', 'proteinaceous', 'purulent', 'blood stained'],
      valid: true,
      walkingDistances: ['Less than 50 metres', '50-100 metres', '100-500 metres', '500-1000 metres', 'Unlimited'],
      xrayStatus: '',
      xrayStatuses: ['ordered', 'sighted']
    }
  },
  computed: {
    bmi () {
      const rawBMI = this.results.weight / Math.pow((this.results.height / 100), 2)
      return Math.round((rawBMI + Number.EPSILON) * 100) / 100
    },
    formattedDate () {
      return DateTime.fromISO(this.encounter.period.start).toFormat('dd/LL/yyyy')
    },
    hipOa () {
      // return this.results.Observation.oa_other_joint.find(joint => joint.endsWith('hip'))
      return (this.results.Observation.oa_index_joint && this.results.Observation.oa_index_joint.endsWith('hip'))
    },
    kneeOa () {
      return this.jointObservations.find(joint => joint.bodyPart.endsWith('knee'))
    },
    xrayStatusHip () {
      if (this.results.ServiceRequest.xray_hip){
        return this.results.ServiceRequest.xray_hip.status === 'sighted'
      }
    }
  },
  watch: {
    // if an index joint has been selected, add the redquired Observation properties
    'results.Observation.oa_index_joint': function (val) {
      const jointProperty = this.toSnakeCase(val)
      console.log('detected - ' + jointProperty)
      if (val && !(`${jointProperty}_kl` in this.results.Observation)) {
        this.results.Observation[`${jointProperty}_kl`] = ''
      }

      if (val && !(`${jointProperty}_range` in this.results.Observation)) {
        this.results.Observation[`${jointProperty}_range`] = ''
      }

      if (val && !(`${jointProperty}_xray` in this.results.Observation)) {
        this.results.Observation[`${jointProperty}_xray`] = { status: ''}
      }
    }
  },
  filters: {
    localeDate: function (val) {
      if (val && dayjs(val).isValid()) return dayjs(val).format('DD/MM/YYYY')
      else return val
    }
  },
  methods: {
    addJoint () {
      this.jointObservations.push({ bodyPart: '', painArea: '', index: false })
    },
    async createEncounter () {
      await this.getPlanDefinition()
      // TODO - hit create encounter array
      try {
        const apiResponse = await apiCall(`/encounter`, 'post', this.encounter)
        this.saved = true
        this.enounter = apiResponse.data
      } catch (e) {
        console.error(e)
      }
    },
    async createSurveySession (surveyName) {
      const surveySessionRequest = {
        encounterId: this.encounter.systemId,
        surveyName
      }
      const urlResponse = await this.axios.put(`${process.env.VUE_APP_API_BASEURL}/survey/session/`, surveySessionRequest)
      if (urlResponse.status === 200) return urlResponse.data
      else console.error(`error - API response: ${urlResponse.status}`)
    },
    getInputCoding (coding) {
      // get the clinres coded element
      console.log('getting input coding')
      return coding.find(coding => coding.system === 'clinres')
    },
    async getPlanDefinition () {
      console.log('getting planDefinition data')
      const planDefinition = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/planDefinition/${this.encounter.basedOn}`)
      this.plan = planDefinition.data
      this.plan.action.forEach(action => {
        if (action.output && action.output.profile.coding) {
          const propertyCode = this.getInputCoding(action.output.profile.coding)
          if (propertyCode) {
            // if array
            if (action.output.profile.multipleResultsAllowed) {
              this.results[action.output.type][propertyCode.code] = []
            } else if (action.output.profile.permittedDataType === 'string') {
              this.results[action.output.type][propertyCode.code] = ''
            }
          }
        }
      })
    },
    isoDate (formattedDate) {
      const isoString = dayjs(formattedDate, ["DD/MM/YYYY", "DD/MM/YY"]).toISOString()
      // if formattedDate is empty, save a blank string
      if (!formattedDate) return ''
      return isoString
    },
    async launchSurvey (surveyName) {
      window.location = await this.createSurveySession(surveyName)
    },
    async saveEncounter () {
      if (this.encounter.results) this.oldResults = {...this.encounter.results}

      this.encounter.results = {...this.results}

      try {
        const saveResponse = await apiCall(`/encounter/${this.encounter.systemId}`, 'put', this.encounter)
        console.log(`api response: ${saveResponse.status} - ${saveResponse.data}`)
        this.encounterSaveSnackbar = true
      } catch (e) {
        console.error(e)
      }
    },
    toggleCharlson () {
      const charlson = { conditions: {} }
      if (!this.results.Observation.charlson) this.$set(this.results.Observation, 'charlson', charlson)
      else {
        console.log('delete charlson')
        this.$delete(this.results.Observation, 'charlson')
      }
    },
    toggleObservation (obsId) {
      const seed = 1
      if (!this.results.Observation[obsId]) this.$set(this.results.Observation, obsId, seed)
      else {
        this.$delete(this.results.Observation, obsId)
      }
    },
    toSnakeCase (val) {
      return val.replace(/\s/g, '_').toLowerCase()
    },
    // when a selection is made, if the result property doesnt exist, create it
    // onObservationMulti(event, code) {
    //   if (!this.results.Observation[code]) {
    //     this.results.Observation[code] = [event]
    //   }
    // },
    onObservationSelection (event, code) {
      if (!this.results.Observation[code]) {
        this.results.Observation[code] = event
      }

      if (this.results.Observation.oa_index_joint && !this.results.Observation.joint_pain_sites) {
        this.results.Observation.joint_pain_sites = []
      }
    },
    onJointSelected (event) {
      console.log(`adding ${event} to oa_body_site`)
      if (!this.results.Observation.oa_body_site) {
        this.results.Observation.oa_body_site = [event]
      } else {
        this.results.Observation.oa_body_site.push(event)
      }

      if (event.endsWith('knee')) {
        this.results.ServiceRequest.xray_knee = { status: '' }
      } else if (event.endsWith('hip')) {
        this.results.ServiceRequest.xray_hip = { status: '' }
      }
    },
    async smsSurvey (surveyName) {
      const surveyURL = await this.createSurveySession(surveyName)
      console.log(`surveyUrl: ${surveyURL}`)

      let smsNumber = this.smsTelecom.value
      if (this.smsTelecom.value.startsWith('0')) smsNumber = `61${smsNumber.substring(1)}`
      console.log(`sending test sms to ${this.smsTelecom.value}`)

      const smsBody = {
        datacoding: 'auto',
        recipients: smsNumber,
        originator: 'STVINCENTS',
        body: `Prior to your upcoming appointment at St Vincent’s Osteoarthritis Specialist Clinic, please complete the survey using the following link: ${surveyURL} This is an automated SMS, please do not reply`
      }
      
      const mesg = querystring.stringify(smsBody)
      const smsResult = await this.axios.post('https://rest.messagebird.com/messages', mesg, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        auth: { username: 'AccessKey', password: process.env.VUE_APP_MESSAGEBIRD_API_KEY }
      })
      if (smsResult.status === 201) this.smsSent = true
      else console.error(smsResult)
    },
    xraySighted (joint) {
      if (this.results.ServiceRequest[`xray_${joint}`]) {
        return this.results.ServiceRequest[`xray_${joint}`].status === 'sighted'
      } else {
        return false
      }
    }
  },
  async created () {
    // populate the patient variable
    const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
    this.patient = results.data
    this.smsTelecom = this.patient.telecom.find(tel => tel.system === 'sms')

    // get the list of PlanDefinitions from the API
    const plans = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/planDefinitions`)
    this.planDefinitions = plans.data
    // if (!isNaN(parseFloat(this.$route.params.patientId))) {
    //   const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
    //   this.patient = results.data
    //   this.patient.birthDate = DateTime.fromISO(this.patient.birthDate)
    // } else {
    if (this.$route.params.encounterId === 'new') {
      this.encounter = {
        identifier: { use: 'official', value: '', assigner: 'SVHM OAHKS Clinic' },
        basedOn: '',
        serviceType: '',
        subject: { type: 'Patient', identifier: this.$route.params.patientId },
        type: '',
        reasonCode: '',
        appointment: '',
        period: { start: DateTime.local().toISO(), end: '' },
        serviceProvider: this.$store.state.init.org.defaults.encounterProvider
      }
      // get a new encounter id from the API
      const incrementRequest = await apiCall(`/encounter/id`, 'get', this.encounter)
      if (incrementRequest) {
        this.$set(this.encounter, 'systemId', incrementRequest.data)
      } else console.log('api call failed')
      this.loaded = true
    } else {
      const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/encounter/${this.$route.params.encounterId}`)
      this.encounter = results.data
      if (results.data) {
        this.loaded = true
        if (results.data.results) {
          this.results = { ...results.data.results }
          if (!results.data.results.Custom) this.results.Custom = {}
        }
      }
      this.saved = this.encounter.systemId !== undefined
    }
  }
  // }
}
</script>
<style module>
.circ {
    stroke-dasharray: 130;
    stroke-dashoffset: 130;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;
}

.quantcontainer {
  display: flex;
}
.quantfield {
  display: inline-block;
  margin-right: 8px;
  width: 90px;
}
.quantunit {
  color: #777777;
  margin: 20px 30px 0 0;
}
</style>

<style scoped>
.sent-indicator-enter-active {
  transition: all .4s ease
}

.sent-indicator-enter, .sent-indicator-leave-to {
  transition: stroke-dashoffset 1s 0.5s
}

</style>
